export default __webpack_public_path__ + "static/media/MC-2.1f44d779.gif";